import script from "./ExamTimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExamTimer.vue?vue&type=script&setup=true&lang=ts"

import "./ExamTimer.vue?vue&type=style&index=0&id=a8a6a352&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8a6a352"]])

export default __exports__